import { useEffect } from "react";
import styles from "./AboutPage.module.less";

import aboutBackground from "app/assets/aboutBackground.webp";

interface Props {
  setBackgroundImage: (src: string) => void;
}

const AboutPage = ({ setBackgroundImage }: Props) => {
  useEffect(() => {
    setBackgroundImage(aboutBackground);
  }, [setBackgroundImage]);

  /*
  <!--
        <p className={classNames(styles.title, styles.textBottom)}>
          «Драйв-групп» - организатор крупнейшего музыкального фестиваля YLETAЙ
        </p>
        <p className={classNames(styles.text, styles.textBottom)}>
          Мы - профессионалы своего дела, имеющие большой опыт работы. Мы дарим
          нашим зрителям то дорогое, что есть в жизни каждого из нас –
          впечатления, эмоции, воспоминания, которые невозможно забыть!
        </p>
        -->
   */
  return (
    <div className={styles.container}>
      <div className={styles.textContainer}>
        <p className={styles.title}>
          Концертное агентство «Драйв-групп» - это:
          <br/>
          - билетная система <a href={'https://drivegrup.ru'}>drivegrup.ru</a>
          <br/>
          - один из ведущих организаторов рок-концертов в Ижевске
          <br/>
          - организатор туров известных рок-групп по Уралу и ПФО
          <br/>
          - проведение каждого концерта на самом высоком уровне
        </p>
        <p className={styles.text}>
          В обойме «Драйв-групп» такие артисты как:
          <br />
          КняZz, Эпидемия, Горшенёв, 7Б, Анимация, Мураками, Инкогнито, Биртман, Крематорий, Lumen, Znaki, Потомучто, Dругой ветер и многие другие.
        </p>
        <div className={styles.spacerInner} />
      </div>
      <div className={styles.spacer} />
    </div>
  );
};

export default AboutPage;
